import { Switch, Tooltip } from "antd";
import { useTemplateData } from "../../hooks/useTemplateData";

export type SceneEnableSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  tooltipTitle: string;
};

export const SceneEnableSwitch = ({
  checked,
  onChange,
  tooltipTitle,
}: SceneEnableSwitchProps) => {
  const {
    mediaGenerationSettingsData: { isMediaSettingsSaving },
  } = useTemplateData();

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.2}>
      <Switch
        size="small"
        checked={checked}
        disabled={isMediaSettingsSaving}
        onChange={onChange}
      />
    </Tooltip>
  );
};
